import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";

export const PermissionChecker = ({
  children,
  permissions = [],
  hideIfNotAllowed = false,
}) => {
  const { allowedPermissions } = useAuth();
  const { selectedApp } = useDashboardContext();

  //if CGM, this permission is not needed
  if (selectedApp == "CGM") {
    return children;
  }

  if (permissions.length == 0) {
    return children;
  }
  if (allowedPermissions.some((ap) => permissions.includes(ap))) {
    return children;
  } else {
    if (hideIfNotAllowed) {
      return null;
    } else {
      return "You are not allowed to access this page!";
    }
  }
};
